module.exports = __webpack_public_path__ + "static/media/bell-ringing-new.85622a82.mp3";